// مجوزهای رسمی کارلند
// تصاویر محلی: فایل‌های زیر را در پوشه public/images/ قرار دهید:
//   logo1.png → نشان اینماد (نماد اعتماد الکترونیکی)
//   logo2.png → مجوز وزارت ارتباطات
//   logo3.png → مجوز وزارت کار

export const licenses = [
  {
    id: 'enamad',
    name: 'نماد اعتماد الکترونیکی',
    shortName: 'اینماد',
    image: '/images/logo1.png',
    fallback: 'https://readdy.ai/api/search-image?query=Professional%20certificate%20badge%20with%20Persian%20text%20emblem%20official%20Iranian%20e-commerce%20trust%20logo%20E-Namad%20style%20blue%20and%20gold%20colors%20on%20white%20background%20clean%20isolated&width=400&height=500&seq=carland-license-enamad-01&orientation=portrait',
  },
  {
    id: 'communications',
    name: 'مجوز وزارت ارتباطات',
    shortName: 'ارتباطات',
    image: '/images/logo2.png',
    fallback: 'https://readdy.ai/api/search-image?query=Official%20Iranian%20government%20ministry%20certificate%20document%20with%20Persian%20text%20and%20official%20seal%20elegant%20frame%20professional%20document%20style%20cream%20and%20gold%20colors&width=400&height=500&seq=carland-license-communications-02&orientation=portrait',
  },
  {
    id: 'labor',
    name: 'مجوز وزارت کار',
    shortName: 'وزارت کار',
    image: '/images/logo3.png',
    fallback: 'https://readdy.ai/api/search-image?query=Official%20labor%20ministry%20employment%20agency%20license%20certificate%20with%20Persian%20text%20professional%20government%20document%20gold%20stamp%20and%20seal%20elegant%20cream%20background&width=400&height=500&seq=carland-license-labor-03&orientation=portrait',
  },
];